export enum VerifiedWithEnum {
  Patient = 1,
  POA = 2,
  Other = 3
}

export const VerifiedWithOptions = [
{ id: 1, label: 'Patient' },
{ id: 2, label: 'POA' },
{ id: 3, label: 'Other' }
];
